module.exports = __webpack_public_path__ + "img/contact.0ec86128.svg";